module.exports = __webpack_public_path__ + "img/1728613103139-WhatsApp Image 2024-10-11 at 10.08.55.jpeg.88af1f2d.webp";